import { RouteRecordRaw } from "vue-router";

import { RouteMeta } from "@/types/routes.interfaces";
import doorman from "@/navigation-guard/doorman";

const routes: Array<RouteRecordRaw> = [
  {
    name: "registerBeNl",
    path: "/",
    alias: "/be-nl",
    component: () => import(/* webpackChunkName: "register" */ "@/views/Register.vue"),
    meta: {
      pageId: 1,
      register: true,
    } as RouteMeta,
    beforeEnter: doorman()
      .checkRelog()
      .isLive({ name: "endBeNl" })
      .subscribe()
      .checkPageView()
      .start(),
  },
  {
    name: "endBeNl",
    path: "/end",
    component: () => import(/* webpackChunkName: "end" */ "@/views/End.vue"),
    meta: {
      pageId: 8,
    } as RouteMeta,
    beforeEnter: doorman().checkPageView().start(),
  },
];
export default routes;
